// @flow
import * as React from "react"
import { compose, withHandlers, type HOC, withStateHandlers } from "recompose"
import withConnect from "hoc/withConnect"
import withOpen from "hoc/withOpen"
import { openModal } from "data/modals/actions"
import SignUp from "modals/SignUp"
import Hamburger from "../../Hamburger"
import SearchAutocomplete from "../../LoggedInNav/SearchAutocomplete"
import { SearchWrapper } from "./styled"

const MobileLoggedOutNav = ({
  hamburgerOpen,
  openHamburger,
  toggleHamburger,
  searchOpen,
  openSearch,
  closeBoth
}) => (
  <React.Fragment>
    <Hamburger
      isOpen={hamburgerOpen}
      open={openHamburger}
      close={closeBoth}
      toggleOpen={toggleHamburger}
    />
    <SearchWrapper>
      <SearchAutocomplete
        initialValue=""
        isOpen={searchOpen}
        open={openSearch}
        close={closeBoth}
      />
    </SearchWrapper>
  </React.Fragment>
)

const mapDispatchToProps = {
  openModal,
}

const enhancer: HOC<*, {||}> = compose(
  withOpen,
  withConnect(() => ({}), mapDispatchToProps),
  withHandlers({
    register: props => () => props.openModal(SignUp, {}),
  }),
  withStateHandlers({
    hamburgerOpen: false,
    searchOpen: false
  },
  {
    closeBoth: () => () => ({ hamburgerOpen: false, searchOpen: false }),
    openHamburger: () => () => ({ hamburgerOpen: true, searchOpen: false }),
    openSearch: () => () => ({ hamburgerOpen: false, searchOpen: true }),
    toggleHamburger: ({ hamburgerOpen }) => () => ({
      searchOpen: false,
      hamburgerOpen: !hamburgerOpen,
    }),
  }
  )
)
export default enhancer(MobileLoggedOutNav)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedOutNav/MobileLoggedOutNav/index.js